
import { Component, Watch, Mixins, Prop, Ref } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import { getPhysiqueSuggest, updatePhysiqueSuggest } from "@/api/physique";

import { getPefHomeHealthAllList, updatePefHomeHealth } from "@/api/lung";

import { handleBackendDataWithDefaults } from "@/utils/common";

import RichText from "@/components/rich-text.vue";
import UploadImg from "@/components/uploadImg.vue";

@Component({ name: 'physique-index',
    components: {
        RichText,
        UploadImg
    }
})
export default class Physique extends Mixins(loading, tablePagination, Resize) {
  @Ref("qtValidateForm") readonly qtValidateForm!: VForm;

  tableData = [];
  itemTotal = 0;

  dialogVisible = false;
  btnLoading = false;
  formData = {
    id: "",
    resultSuggestion: "",
  };
  editorOption = {
    modules: {
      toolbar: [["bold", { color: [] }], [{ size: [] }]],
    },
  };

  qtDialogVisible = false;
  qtBtnLoading = false;
  qtFormData = {
    id: "",
    title: "",
    zzName: "",
    physiqueImage: [],       // 体质图片（通用）
    myPhysique: "",
    reason: "",
    physiqueAnalysis: "",
    preventDisease: "",
    homeHealth: "",
    physiqueImageM: [],      // 体质图片（男性）
    myPhysiqueM: "",
    reasonM: "",
    physiqueAnalysisM: "",
    preventDiseaseM: "",
    homeHealthM: "",
    physiqueImageW: [],      // 体质图片（女性）
    myPhysiqueW: "",
    reasonW: "",
    physiqueAnalysisW: "",
    preventDiseaseW: "",
    homeHealthW: "",
    minorityPhysiqueImage: [],  // 体质图片（未成年）
    minorityMyPhysique: "",
    minorityReason: "",
    minorityPhysiqueAnalysis: "",
    minorityPreventDisease: "",
    minorityHomeHealth: "",
  };
  qtFormRules = {
    // 体质图片必填（仅通用）
    physiqueImage: [{ required: true, validator: this.validatePhysiqueImage, trigger: "change" }],
    myPhysique: [{ required: true, message: "请输入我的体质", trigger: "blur" }],
    reason: { required: true, message: "请输入形成原因", trigger: "blur" },
    physiqueAnalysis: { required: true, message: "请输入体质解密", trigger: "blur" },
  }

  /** 体质图片必填校验：空数组或无值则提示 */
  validatePhysiqueImage(rule, value, callback) {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      callback(new Error("请上传体质图片"));
    } else {
      callback();
    }
  }

  activeName = "first";
  mounted() {
    this.windowResize(180);
    this.getData();
  }

  getData() {
    this.showLoading();
    getPhysiqueSuggest().then((res) => {
      this.tableData = res.data || [];
    }).finally(() => {
      this.hideLoading();
    })
  }

  // 其他配置
  setQt(row) {
    this.qtDialogVisible = true;
    const { id, symptom, myPhysique, reason, physiqueAnalysis, preventDisease, homeHealth, myPhysiqueM, reasonM, physiqueAnalysisM, preventDiseaseM, homeHealthM, myPhysiqueW, reasonW, physiqueAnalysisW, preventDiseaseW, homeHealthW, minorityMyPhysique, minorityReason, minorityPhysiqueAnalysis, minorityPreventDisease, minorityHomeHealth,
      // 体质图片字段
      physiqueImage, physiqueImageM, physiqueImageW, minorityPhysiqueImage
    } = row;
    this.qtFormData.zzName = symptom;
    this.qtFormData.id = row.id;
    this.qtFormData.title = symptom;
    Object.assign(this.qtFormData, { myPhysique, reason, physiqueAnalysis, preventDisease, homeHealth, myPhysiqueM, reasonM, physiqueAnalysisM, preventDiseaseM, homeHealthM, myPhysiqueW, reasonW, physiqueAnalysisW, preventDiseaseW, homeHealthW, minorityMyPhysique, minorityReason, minorityPhysiqueAnalysis, minorityPreventDisease, minorityHomeHealth,
      // 体质图片初始化（后端返回字符串时转为数组格式）
      physiqueImage: physiqueImage ? (Array.isArray(physiqueImage) ? physiqueImage : [{ url: physiqueImage }]) : [],
      physiqueImageM: physiqueImageM ? (Array.isArray(physiqueImageM) ? physiqueImageM : [{ url: physiqueImageM }]) : [],
      physiqueImageW: physiqueImageW ? (Array.isArray(physiqueImageW) ? physiqueImageW : [{ url: physiqueImageW }]) : [],
      minorityPhysiqueImage: minorityPhysiqueImage ? (Array.isArray(minorityPhysiqueImage) ? minorityPhysiqueImage : [{ url: minorityPhysiqueImage }]) : [],
    })
  }

  qtDialogConfirm() {
    this.qtValidateForm?.validate().then(() => {
        this.qtBtnLoading = true;
        const params = { ...this.qtFormData };
        // 体质图片：数组转字符串，取第一张图片的url
        if (Array.isArray(params.physiqueImage)) params.physiqueImage = params.physiqueImage[0]?.url || "";
        if (Array.isArray(params.physiqueImageM)) params.physiqueImageM = params.physiqueImageM[0]?.url || "";
        if (Array.isArray(params.physiqueImageW)) params.physiqueImageW = params.physiqueImageW[0]?.url || "";
        if (Array.isArray(params.minorityPhysiqueImage)) params.minorityPhysiqueImage = params.minorityPhysiqueImage[0]?.url || "";
        updatePhysiqueSuggest(params).then(() => {
          this.$message.success("操作成功");
          this.getData();
          this.qtDialogClose();
        }).finally(() => {
          this.qtBtnLoading = false;
        })
    })
  }

  qtDialogClose() {
    this.qtDialogVisible = false;
    this.activeName = "first";
    this.qtValidateForm?.resetFields();
    this.qtFormData.zzName = "";
    this.qtFormData.id = "";
    this.qtFormData.title = "";
    // 重置体质图片字段
    this.qtFormData.physiqueImage = [];
    this.qtFormData.physiqueImageM = [];
    this.qtFormData.physiqueImageW = [];
    this.qtFormData.minorityPhysiqueImage = [];
  }

  // 膳食运动
  setJj(row: { id: string; resultSuggestion: string }) {
    this.formData.id = row.id;
    this.formData.resultSuggestion = row.resultSuggestion;
    this.dialogVisible = true;
  }

  dialogClose() {
    this.dialogVisible = false;
    this.btnLoading = false;
    // @ts-ignore
    this.$refs.validateForm?.resetFields();
    this.formData.id = "";
  }

  dialogConfirm() {
    this.btnLoading = true;
    updatePefHomeHealth(this.formData)
      .then((res) => {
        this.$message.success("操作成功");
        this.dialogClose();
        this.getData();
      })
      .catch(() => {
        this.btnLoading = false;
      });
  }
  // @Watch("qtFormData", { deep: true })
  // checkQtFormData() {
  //   // @ts-ignore
  //   this.qtValidateForm?.validateField(["physiqueAnalysis", "reason", "myPhysique"]);
  // }
}
